import AxiosClient from "../../../services/axios.services";

class GeneralDataServices {
  getGeneralData = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_datos_generales/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getGeneralDataById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_datos_generales/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveGeneralData = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_datos_generales/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editGeneralData = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_datos_generales/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteGeneralData = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_datos_generales/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
    mailSendGeneralInfo = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_envio_correo/", data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new GeneralDataServices();
